import { loop, Marquee as DynamicMarquee } from 'dynamic-marquee';

class Marquee {
    constructor(block) {
        this.root = block.querySelector('.marquee__wrapper');
        if (!this.root) return;

        this.marquee = null;

        this.buildMarquee();
        this.loop();
    }

    buildMarquee() {
        this.marquee = new DynamicMarquee(this.root, {
            rate: 100,
            startOnScreen: false,
        });
    }

    forceRepaint() {
        this.root.style.paddingRight = '0.1px';

        requestAnimationFrame(() => {
            this.root.style.paddingRight = '0px';
            requestAnimationFrame(() => {
                this.forceRepaint();
            });
        });
    }

    loop() {
        const { marquee, root } = this;
        const content = JSON.parse(root.getAttribute('data-marquee-content'));

        let elements = [];

        content.reverse().forEach((elem) => {
            elements = [
                ...elements,
                () => {
                    const image = document.createElement('img');
                    image.classList.add('marquee__image');
                    image.src = elem.src;
                    image.alt = elem.alt;
                    image.width = 200;
                    image.height = 200;

                    const wrapper = document.createElement('span');
                    wrapper.classList.add('marquee__image-wrapper');
                    wrapper.append(image);

                    return wrapper;
                },
            ];
        });

        loop(marquee, elements);

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (!isSafari) return;
        this.forceRepaint();
    }
}

const initMarqueeBlocks = () => {
    const marquees = document.querySelectorAll('.marquee');
    if (!marquees) return;

    marquees.forEach((m) => {
        new Marquee(m); // eslint-disable-line
    });
};

export { initMarqueeBlocks, Marquee };
